import { FC } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';

export const BouncingLoader: FC<{ containerStyles?: Interpolation<Theme> }> = ({ containerStyles }) => {
  return (
    <div css={[styles.container, containerStyles]}>
      <motion.div
        animate={{
          y: ['100%', '-100%', '100%'],
        }}
        transition={{
          repeat: Infinity,
          duration: 0.75,
          stiffness: 50,
          damping: 0,
        }}
        css={styles.ball}
      />
    </div>
  );
};

const styles = {
  container: css`
    height: 32px;
    flex-shrink: 0;
    position: relative;
  `,
  ball: css`
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: ${theme.borderRadius.full};
    background: linear-gradient(
      45.06deg,
      #ff7301 2.26%,
      ${theme.colors.secondary.eggplant50} 50%,
      ${theme.colors.secondary.seaweed50} 97.74%
    );
  `,
};
